<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ title }}</ion-title>

        <ion-buttons slot="end">
          <ion-button @click="close">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>

      <iframe
        :src="url"
        style="width:100%; height:100%; border:none;"
      ></iframe>

    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from "vue";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  modalController,
} from "@ionic/vue";

export default defineComponent({
  name: "chargerSetupModel",

  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
  },

  props: {
    title: String,
    url: String,
  },

  methods: {
    close() {
      modalController.dismiss({
        status: "closed",
      });
    },
  },
});
</script>